import { sum } from 'lodash';
import PropTypes from 'prop-types';
import { Page, View, Text, Font, Image, Document, StyleSheet } from '@react-pdf/renderer';
// utils
import { fCurrency } from "src/utils/formatNumber";

// ----------------------------------------------------------------------

Font.register({
    family: 'Roboto',
    fonts: [{ src: '/fonts/Roboto-Regular.ttf' }, { src: '/fonts/Roboto-Bold.ttf' }]
});

const styles = StyleSheet.create({
    col4: { width: '25%' },
    col8: { width: '75%' },
    col6: { width: '50%' },
    mb8: { marginBottom: 8 },
    mb40: { marginBottom: 40 },
    overline: {
        fontSize: 8,
        marginBottom: 8,
        fontWeight: 700,
        letterSpacing: 1.2,
        textTransform: 'uppercase'
    },
    h3: { fontSize: 16, fontWeight: 700 },
    h4: { fontSize: 13, fontWeight: 700 },
    body1: { fontSize: 10 },
    subtitle2: { fontSize: 9, fontWeight: 700 },
    alignRight: { textAlign: 'right' },
    page: {
        padding: '40px 24px 0 24px',
        fontSize: 9,
        lineHeight: 1.6,
        fontFamily: 'Roboto',
        backgroundColor: '#fff',
        textTransform: 'capitalize'
    },
    footer: {
        left: 0,
        right: 0,
        bottom: 0,
        padding: 24,
        margin: 'auto',
        borderTopWidth: 1,
        borderStyle: 'solid',
        position: 'absolute',
        borderColor: '#DFE3E8'
    },
    gridContainer: { flexDirection: 'row', justifyContent: 'space-between' },
    table: { display: 'flex', width: 'auto' },
    tableHeader: {},
    tableBody: {},
    tableRow: {
        padding: '8px 0',
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderStyle: 'solid',
        borderColor: '#DFE3E8'
    },
    noBorder: { paddingTop: 8, paddingBottom: 0, borderBottomWidth: 0 },
    tableCell_1: { width: '5%' },
    tableCell_2: { width: '50%', paddingRight: 16 },
    tableCell_3: { width: '15%' }
});

// ----------------------------------------------------------------------

InvoicePDF.propTypes = {
    invoice: PropTypes.object.isRequired
};

export default function InvoicePDF({ data }) {
    console.log(data)
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.gridContainer, styles.mb40]}>
                    <Image source="/logoMain.png" style={{ height: 32, }} />
                    <View style={{ alignItems: 'right', flexDirection: 'column' }}>
                        <Text style={styles.h3}>{data?.status}</Text>
                        <Text>INV-{data?._id}</Text>
                    </View>
                </View>

                <View style={[styles.gridContainer, styles.mb40]}>
                    <View style={styles.col6}>
                        <Text style={[styles.overline, styles.mb8]}>Invoice from</Text>
                        <Text style={styles.body1}>Commerchope</Text>
                        <Text style={styles.body1}>Sargodha, Pakistan</Text>
                        <Text style={styles.body1}>+92 303 5501602</Text>
                        <Text style={styles.body1}> info@commercehope.com</Text>
                    </View>
                    <View style={styles.col6}>
                        <Text style={[styles.overline, styles.mb8]}>Invoice to</Text>
                        <Text style={styles.body1}>{data?.user?.fullName}</Text>
                        <Text style={styles.body1}>{data?.user?.address}{data?.user?.zip}{data?.user?.city}{data?.user?.state}{data?.user?.country}</Text>
                        <Text style={styles.body1}>{data?.user?.phone}</Text>
                        <Text style={styles.body1}>{data?.user?.email}</Text>
                    </View>
                </View>

                <Text style={[styles.overline, styles.mb8]}>Invoice Details</Text>

                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        <View style={styles.tableRow}>
                            <View style={styles.tableCell_1}>
                                <Text style={styles.subtitle2}>#</Text>
                            </View>
                            <View style={styles.tableCell_2}>
                                <Text style={styles.subtitle2}>Product Name</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Color</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Size</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Qty</Text>
                            </View>
                            <View style={styles.tableCell_3}>
                                <Text style={styles.subtitle2}>Unit price</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text style={styles.subtitle2}>Total</Text>
                            </View>
                        </View>
                    </View>

                    <View style={styles.tableBody}>
                        {data?.items.map((item, index) => (
                            <View style={styles.tableRow} key={item.id}>
                                <View style={styles.tableCell_1}>
                                    <Text>{index + 1}</Text>
                                </View>
                                <View style={styles.tableCell_2}>
                                    <Text style={styles.subtitle2}>{item.variantName}</Text>

                                </View>
                                <View style={styles.tableCell_3}>
                                    <Text>{item.color}</Text>
                                </View>
                                <View style={styles.tableCell_3}>
                                    <Text>{item.size}</Text>
                                </View>
                                <View style={styles.tableCell_3}>
                                    <Text>{item.quantity}</Text>
                                </View>
                                <View style={styles.tableCell_3}>
                                    <Text>{item.price}</Text>
                                </View>
                                <View style={[styles.tableCell_3, styles.alignRight]}>
                                    <Text>{fCurrency(item.price * item.quantity)}</Text>
                                </View>
                            </View>
                        ))}

                        <View style={[styles.tableRow, styles.noBorder]}>
                            <View style={styles.tableCell_1} />
                            <View style={styles.tableCell_2} />
                            <View style={styles.tableCell_3} />
                            <View style={styles.tableCell_3}>
                                <Text>Subtotal</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text>
                                    {fCurrency(data?.subTotal)}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.noBorder]}>
                            <View style={styles.tableCell_1} />
                            <View style={styles.tableCell_2} />
                            <View style={styles.tableCell_3} />
                            <View style={styles.tableCell_3}>
                                <Text>Discount</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text>

                                    {fCurrency(data?.discount)}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.noBorder]}>
                            <View style={styles.tableCell_1} />
                            <View style={styles.tableCell_2} />
                            <View style={styles.tableCell_3} />
                            <View style={styles.tableCell_3}>
                                <Text>Shipping</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text>
                                    {fCurrency(data?.shipping)}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow, styles.noBorder]}>
                            <View style={styles.tableCell_1} />
                            <View style={styles.tableCell_2} />
                            <View style={styles.tableCell_3} />
                            <View style={styles.tableCell_3}>
                                <Text style={styles.h4}>Total</Text>
                            </View>
                            <View style={[styles.tableCell_3, styles.alignRight]}>
                                <Text style={styles.h4}>
                                    {fCurrency(data?.total)}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={[styles.gridContainer, styles.footer]}>
                    <View style={styles.col8}>
                        <Text style={styles.subtitle2}>NOTES</Text>
                        <Text>We appreciate your business. Should you need us to add VAT or extra notes let us know!</Text>
                    </View>
                    <View style={[styles.col4, styles.alignRight]}>
                        <Text style={styles.subtitle2}>Have a Question?</Text>
                        <Text> info@commercehope.com</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
}
